import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Send } from 'lucide-react';
const locations = ['Midland', 'Saginaw', 'Caro', 'Bridgeport', 'Hemlock', 'Bay City'];
export function ContactForm() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    location: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission placeholder - no actual destination
    console.log('Contact Form Placeholder - No submission destination specified');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section className="py-16 bg-white" data-id="element-42">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-lg p-8 md:p-10" data-id="element-44">
          <div className="text-center mb-8" data-id="element-45">
            <h2 className="text-3xl font-bold text-[#1a2332] mb-2" data-id="element-46">
              Send Us a Message
            </h2>
            <p className="text-slate-600" data-id="element-47">
              Have questions? We're here to help. Reach out and we'll get back
              to you soon.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-48">
            {/* Name Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-49">
              <div data-id="element-50">
                <label htmlFor="firstName" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-51">
                  First Name <span className="text-[#dc2626]" data-id="element-52">*</span>
                </label>
                <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} required className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" placeholder="Enter your first name" data-id="element-53" />
              </div>

              <div data-id="element-54">
                <label htmlFor="lastName" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-55">
                  Last Name <span className="text-[#dc2626]" data-id="element-56">*</span>
                </label>
                <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} required className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" placeholder="Enter your last name" data-id="element-57" />
              </div>
            </div>

            {/* Contact Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-58">
              <div data-id="element-59">
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-60">
                  Email Address <span className="text-[#dc2626]" data-id="element-61">*</span>
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" placeholder="your.email@example.com" data-id="element-62" />
              </div>

              <div data-id="element-63">
                <label htmlFor="phone" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-64">
                  Phone Number <span className="text-[#dc2626]" data-id="element-65">*</span>
                </label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#dc2626] focus:border-transparent" placeholder="(555) 123-4567" data-id="element-66" />
              </div>
            </div>

            {/* Location Dropdown */}
            <div data-id="element-67">
              <label htmlFor="location" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-68">
                Preferred Location <span className="text-[#dc2626]" data-id="element-69">*</span>
              </label>
              <select id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#dc2626] focus:border-transparent appearance-none bg-white" data-id="element-70">
                <option value="" disabled data-id="element-71">
                  Select a location...
                </option>
                {locations.map(loc => <option key={loc} value={loc} data-id="element-72">
                    {loc}
                  </option>)}
              </select>
            </div>

            {/* Message Field */}
            <div data-id="element-73">
              <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-74">
                Message <span className="text-slate-400" data-id="element-75">(Optional)</span>
              </label>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={5} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#dc2626] focus:border-transparent resize-none" placeholder="Tell us about your interest in martial arts training..." data-id="element-76" />
            </div>

            {/* Submit Button */}
            <div className="pt-4" data-id="element-77">
              <Button type="submit" variant="primary" size="lg" className="w-full justify-center" data-id="element-78">
                <Send className="mr-2 h-5 w-5" data-id="element-79" />
                Send Message
              </Button>
            </div>
          </form>
        </div>
      </div>
    </section>;
}